"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopperCard = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var framer_motion_1 = require("framer-motion");
var core_1 = require("@material-ui/core");
var card_1 = require("../card/card");
var popper_card_styles_1 = require("./popper_card_styles");
var speech_bubble_arrow_component_1 = require("../assets/icons/speech_bubble_arrow_component");
var merge_1 = __importDefault(require("lodash/merge"));
var useStyles = styles_1.makeStyles(popper_card_styles_1.styles);
var PopperCard = function (_a) {
    var className = _a.className, anchorElement = _a.anchorElement, open = _a.open, onClose = _a.onClose, popperProps = _a.popperProps, structured = _a.structured, onClickAway = _a.onClickAway, _b = _a.dismissArrow, dismissArrow = _b === void 0 ? false : _b, _c = _a.customClasses, oldCustomClasses = _c === void 0 ? {} : _c, _d = _a.classes, receivedClasses = _d === void 0 ? {} : _d, _e = _a.containerProps, containerProps = _e === void 0 ? {} : _e, children = _a.children;
    var mergedClasses = react_1.useMemo(function () { return merge_1.default({}, oldCustomClasses, receivedClasses); }, [
        JSON.stringify(oldCustomClasses),
        JSON.stringify(receivedClasses),
    ]);
    var classes = useStyles({ classes: mergedClasses });
    var _f = react_1.useState(null), arrowReference = _f[0], setArrowReference = _f[1];
    return (react_1.default.createElement(core_1.Popper, __assign({}, { open: open }, containerProps, { className: classnames_1.default(classes.popper, !open && classes.closedPopper, receivedClasses.popper, containerProps.className), anchorEl: anchorElement }, popperProps, { modifiers: __assign({ flip: {
                enabled: true,
            }, preventOverflow: {
                enabled: true,
                boundariesElement: 'scrollParent',
            }, arrow: {
                enabled: !dismissArrow,
                element: arrowReference,
            } }, (popperProps && popperProps.modifiers)), transition: true }), function (_a) {
        var TransitionProps = _a.TransitionProps;
        return (react_1.default.createElement(Fade, __assign({}, TransitionProps, popperProps),
            react_1.default.createElement(Content, __assign({}, {
                className: className,
                setArrowReference: setArrowReference,
                structured: structured,
                dismissArrow: dismissArrow,
                onClickAway: onClickAway,
                classes: classes,
            }), children)));
    }));
};
exports.PopperCard = PopperCard;
var Fade = function (props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, popperProps = props.popperProps, other = __rest(props, ["in", "children", "onEnter", "onExited", "popperProps"]);
    var getTranslationFromPlacement = react_1.useCallback(function (value) {
        var placement = (popperProps && popperProps.placement) || 'bottom';
        if (['top', 'bottom'].some(function (key) { return placement === key; })) {
            return "translate3d(0, " + value + "px, 0)";
        }
        return "translate3d(-" + value + "px, 0, 0)";
    }, []);
    var motionConfig = {
        onStart: function () {
            // This cause the following error: Cannot update a component from inside the function body of a different component.
            // It is a pattern documented in the Transition section of Material-UI docs, waiting for a possible update.
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function () {
            if (!open && onExited) {
                onExited();
            }
        },
    };
    return (react_1.default.createElement(framer_motion_1.motion.div, __assign({}, { ref: ref, motionConfig: motionConfig }, { style: { pointerEvents: open ? 'all' : 'none' }, initial: {
            opacity: 0,
            transform: getTranslationFromPlacement(20),
        }, animate: {
            opacity: open ? 1 : 0,
            transform: getTranslationFromPlacement(open ? 0 : 20),
        }, transition: { type: 'spring' } }, other), children));
};
var Content = function (_a) {
    var className = _a.className, dismissArrow = _a.dismissArrow, setArrowReference = _a.setArrowReference, onClickAway = _a.onClickAway, structured = _a.structured, classes = _a.classes, children = _a.children;
    var handleClickAway = react_1.useCallback(function () {
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        if (typeof onClickAway === 'function') {
            onClickAway.apply(void 0, parameters);
        }
    }, [onClickAway]);
    var content = (react_1.default.createElement("div", { className: classes.wrapper },
        !dismissArrow && (react_1.default.createElement("div", { className: classnames_1.default(classes.arrowContainer), ref: setArrowReference },
            react_1.default.createElement(speech_bubble_arrow_component_1.SpeechBubbleArrow, null))),
        react_1.default.createElement(card_1.Card, { className: classnames_1.default(className, classes.container, structured && classes.structured) }, children)));
    if (onClickAway) {
        return react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: handleClickAway }, content);
    }
    return content;
};
